module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAMAAABhEH5lAAAAAXNSR0IB2cksfwAAAEVQTFRFAAAAcHBwZ2dxaGhwaGhxaGhyZ2dxaGhxaGhxaGhxaGhxaGhxaGhxaGhwaWlwampwaGhxaGhwaGhxaWlyaGhwZ2dyaWlxda5t5wAAABd0Uk5TABBPf7+A7/+woODA0CBQMPBAkHCfrz9iSl2EAAAAlElEQVR4nFVQ4RqEIAgDEyntyOuq93/UQ7D84ofOsU0FoBWGKcYpIDxFia3S1AmM7TgvWdfowqJw/TRx46AD9uaqiNRmOfDoE4LwW8XivgSDIhMzb0bVBkunxkVK+W5h5lOjx/NXKUcCaAF1u6OqJdRF/GeyZ/7ZA48xgH32Zjn7VPCc7/lQPsJ1hSPT0KNQKSQu+QPgTgY6DVNUGQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/temp/ico-user.png
// module id = 759
// module chunks = 1